import React from 'react';
import { Box } from '../../base/Box/Box';
import { PortfolioCardsSectionStoryblok } from '../../types/storyblok';

export const PortfolioCardsSection = ({
  heading,
  colourScheme = 'white',
  overlayOverBkg,
}: PortfolioCardsSectionStoryblok) => {
  if (!heading) {
    return null;
  }

  return (
    <Box
      as="section"
      colourScheme={colourScheme || 'white'}
      blockSpacing
      bkg
      overlayOverBkg={overlayOverBkg}
    >
      PortfolioCardsSection
    </Box>
  );
};

export default PortfolioCardsSection;
